import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { AppCustomPreloader } from './app-custom-preloader';
import { PagenotfoundModule } from './pagenotfound/pagenotfound.module';
import { RestService } from './Services/Rest/rest.service';
import { AuthGuardService } from './Services/AuthGuard/auth-guard.service';
import { MaterialSharedModuleAll } from './shared/material/material-shared-moduleall';
import { AuthenticationService } from './shared/services/authentication.service';
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import { initializer } from './app-init';
import { HeaderComponent } from './header/header.component';
import { LocationStrategy, PathLocationStrategy, DatePipe } from '@angular/common';
// import { ModalModule } from 'ngx-bootstrap/modal';
import { ModalDialogModule } from 'ngx-modal-dialog';
import { OrderService } from './shared/services/order.service';
import { BorrowerService } from './place-order-borrower/place-order-borrower/place-order-borrower.service';
import { LoginGstService } from './login-gst-borrower/login-gst/login-gst.service';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { UserPreferencesService } from './shared/services/user-preferences.service';
import { SharedComponentModule } from './shared/component/sharedcomponent.module';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    PagenotfoundModule,
    MaterialSharedModuleAll,
    NgxDropzoneModule,
    KeycloakAngularModule,
    // ModalDialogModule.forRoot(),
    SharedComponentModule,
    ToastrModule.forRoot({
      positionClass :'toast-bottom-right'
    })
   ],
  exports: [
    HeaderComponent,
    
 
],
  providers: [
    AppCustomPreloader,
    AuthGuardService,
    RestService,
    AuthenticationService,
    OrderService,
    BorrowerService,
    LoginGstService,
    UserPreferencesService,
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      multi: true,
      deps: [KeycloakService]
  },{provide: LocationStrategy, useClass: PathLocationStrategy}

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
